import { err, ok } from '@orbit-mind/shared-types';
export async function syncLibrary(options) {
    let failed = 0;
    const queued = await options.catalog.pendingTrash();
    if (!queued.ok)
        return err(queued.error);
    for (const change of queued.value) {
        const sent = await options.transport.setTrashed(change.mapId, change.deletedAt !== null);
        // A local-only map has nothing on the server to delete or restore.
        if (sent.ok || sent.error.code === 'MAP_NOT_FOUND') {
            const acknowledged = await options.catalog.acknowledgeTrash(change);
            if (!acknowledged.ok)
                failed += 1;
        }
        else
            failed += 1;
    }
    const remaining = await options.catalog.pendingTrash();
    if (!remaining.ok)
        return err(remaining.error);
    const pendingIds = new Set(remaining.value.map((change) => change.mapId));
    const listed = await options.transport.list({ includeTrashed: true });
    if (!listed.ok)
        return err(listed.error);
    let added = 0;
    let updated = 0;
    for (const remote of listed.value) {
        if (options.isCancelled?.() === true)
            break;
        const local = await options.catalog.get(remote.mapId);
        if (!local.ok) {
            failed += 1;
            continue;
        }
        if (pendingIds.has(remote.mapId))
            continue;
        // Do not resurrect a map whose local copy was permanently removed from the trash.
        if (local.value === undefined && remote.deletedAt != null)
            continue;
        if (local.value === undefined) {
            const pulled = await options.transport.pull(remote.mapId);
            if (options.isCancelled?.() === true)
                break;
            if (!pulled.ok) {
                failed += 1;
                continue;
            }
            const created = await options.catalog.create(pulled.value.document, options.now());
            if (created.ok)
                added += 1;
            else
                failed += 1;
            continue;
        }
        const map = local.value.map;
        if (remote.deletedAt !== undefined && remote.deletedAt !== map.deletedAt) {
            const applied = await options.catalog.applyRemoteTrash(remote.mapId, remote.deletedAt);
            if (!applied.ok) {
                failed += 1;
                continue;
            }
            updated += 1;
        }
        const deletedAt = remote.deletedAt === undefined ? map.deletedAt : remote.deletedAt;
        if (deletedAt !== null)
            continue;
        if (remote.revision <= map.serverRevision)
            continue;
        // Unsent edits: this map's own sync owes the server something, and replacing the copy here
        // would throw that work away.
        let pending;
        try {
            pending = (await options.journal.readPending(remote.mapId)).records.length;
        }
        catch {
            failed += 1;
            continue;
        }
        if (pending > 0)
            continue;
        const pulled = await options.transport.pull(remote.mapId);
        if (options.isCancelled?.() === true)
            break;
        if (!pulled.ok) {
            failed += 1;
            continue;
        }
        // Recheck the outbox inside the same transaction that replaces the document.
        const saved = await options.catalog.replace(pulled.value.document, options.now());
        if (saved.ok)
            updated += 1;
        else
            failed += 1;
    }
    return ok({ added, updated, failed });
}
//# sourceMappingURL=library.js.map